import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { KendoNotificationService } from '../services/common/kendo-notification.service';
import { LoggerService } from '../services/common/logger.service';

// https://stackoverflow.com/questions/49578729/angular-http-catch-not-handling-neterr-connection-reset
// https://angular.io/guide/http-handle-request-errors
export function handleHttpError(
  error: HttpErrorResponse,
  logger: LoggerService,
  kns: KendoNotificationService | null = null,
) {
  if (error.status === 0) {
    // A client-side or network error occurred. Handle it accordingly.
    logger.error(
      `Client-browser or network returned error: An error occurred calling url: ${error.url}. The status was ${error.status} ${error.statusText}.`,
      `HttpHeaders: ${JSON.stringify(error.headers)}`,
      JSON.stringify(error),
    );
  } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong.
    logger.error(
      `Server returned error: An error occurred calling url: ${error.url}. The status was ${error.status} ${error.statusText}.`,
      `HttpHeaders: ${JSON.stringify(error.headers)}`,
      JSON.stringify(error),
    );
  }

  // Return an observable with a user-facing error message.
  const userError: string =
    'Something went wrong. Please refresh the page and try again.';
  if (kns) kns.show('error', userError);
  return throwError(() => new Error(userError));
}
